/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[29]",
    title: "Sản lượng dầu khí xuất bản",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[29a]",
    title: "Sản lượng dầu thô, khí thiên nhiên xuất bản quy đổi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[29b]",
    title: "Hệ số quy đổi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[30]",
    title: "Giá bán",
  },
  {
    id: uuidV4(),
    value4: "USD",
    value5: "",
    spendId: "[31]",
    title: "Doanh thu",
  },
  {
    id: uuidV4(),
    value4: "%",
    value5: "",
    spendId: "[32]",
    title: "Tỷ lệ thuế TNDN tạm tính",
  },
  {
    id: uuidV4(),
    value4: "USD",
    value5: "",
    spendId: "[33]",
    title: "Thu nhập khác liên quan trực tiếp đến hoạt động dầu khí",
  },
  {
    id: uuidV4(),
    value4: "%",
    value5: "",
    spendId: "[34]",
    title: "Thuế suất thuế TNDN hoạt động dầu khí",
  },
  {
    id: uuidV4(),
    value4: "USD",
    value5: "",
    spendId: "[35]",
    title: "Số thuế TNDN tạm tính phải nộp [35]=[31]x[32]+[33]x[34]",
  },
  {
    id: uuidV4(),
    value4: "USD",
    value5: "",
    spendId: "[36]",
    title: "Số thuế TNDN được miễn hoặc giảm (nếu có)",
  },
  {
    id: uuidV4(),
    value4: "USD",
    value5: "",
    spendId: "[37]",
    title: "Số thuế TNDN tạm tính phải nộp sau khi miễn hoặc giảm (nếu có) [37]=[35]-[36]",
  },
  {
    id: uuidV4(),
    value4: "VND/USD",
    value5: "",
    spendId: "[38]",
    title: "Tỷ giá quy đổi",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Số tiền
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: [9, 11].includes(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {index + 1 > 1 && index + 1 < 4 ? "" : index + 1}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: [9, 11].includes(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: [9, 11].includes(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.spendId}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: [9, 11].includes(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {index + 1 > 4 ? (
                    item.value4
                  ) : (
                    <select
                      style={selectStyle}
                      onChange={(e) =>
                        handleChange({ id: item.id, value: e.target.value, name: "value4" })
                      }
                    >
                      <option value="1">USD</option>
                      <option value="2">VND</option>
                    </select>
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: [9, 11].includes(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  0
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
